import { render, staticRenderFns } from "./KnivesetsSelectStatusTransition.vue?vue&type=template&id=4013eb06&scoped=true&"
import script from "./KnivesetsSelectStatusTransition.vue?vue&type=script&lang=ts&"
export * from "./KnivesetsSelectStatusTransition.vue?vue&type=script&lang=ts&"
import style0 from "./KnivesetsSelectStatusTransition.vue?vue&type=style&index=0&id=4013eb06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013eb06",
  null
  
)

export default component.exports